const qna = [
  {
    q: "Who can Attend?",
    a: "If you are a student enrolled in any high school or post secondary institution, you are eligible to apply and attend RU Hacks.",
  },
  {
    q: "When can I sign up for RU Hacks?",
    a: "Hacker applications for RU Hacks 2022 open on March 4, 2022 at 6:00 PM EST. Stay tuned for our App Portal to check your application status and check out our social media for round acceptance announcements!",
  },
  {
    q: "How much does it cost to attend RU Hacks?",
    a: "Admission to RU Hacks is completely free!",
  },
  {
    q: "Do I need prior technical and coding skills to attend?",
    a: "No, prior coding or technical experience is not necessary. RU Hacks is a fun learning experience where we’ll be hosting beginner workshops, talks and mentors to guide you through projects.",
  },
  {
    q: "Can I start working on my hack before the event?",
    a: "No, we do not allow participants to work on pre-existing projects. RU Hacks hackers are required to start and complete their project during the hackathon. However, you are welcome to familiarize yourself with specific tools and technologies beforehand!",
  },
  {
    q: "How does judging work?",
    a: "Our panel of judges come from a variety of backgrounds and fields. More specific judging criteria will be sent to you closer to the hackathon. The top projects will get a chance to show their recorded demos in front of all of RU Hacks during the closing ceremony.",
  },
  {
    q: "What about Hardware Hacks?",
    a: "You are welcome to create a hardware hack, but we ask that you respect COVID-19 restrictions while doing so. More information will be released closer to the hackathon.",
  },
  {
    q: "What is the maximum team size?",
    a: "A single team can consist of 1 to 4 people. If you are looking to find other hackers to compete alongside, we encourage you to join our Team Formation session at the start of the hackathon on the RU Hacks 2022 Discord!",
  },
];

export default qna;
